import { jsx } from "react/jsx-runtime";
import { useBlockSignal as m } from "../../cms-utils/dist/index.esm.esm.js";
import { dynamic } from "@zillow/frontier/dynamic";
import { remote } from "@zillow/frontier/import";
const AgentShoppingRemote = dynamic(() => remote("agent-shopping-subapp/AgentShoppingActivationLandingPage"), {
  render: "csr",
  type: "remote",
  module: "agent-shopping-subapp/AgentShoppingActivationLandingPage"
});
const AgentShoppingBlock = ({
  attrs
}) => {
  const zpid = m("propertySearch.zpid");
  const blockAttrs = {
    ...attrs,
    property: zpid !== void 0 ? {
      zpid
    } : void 0,
    triggerLocation: (attrs == null ? void 0 : attrs.triggerLocation) || "activation_landing_page",
    carouselOrientation: (attrs == null ? void 0 : attrs.carouselOrientation) || "vertical"
  };
  return /* @__PURE__ */ jsx(AgentShoppingRemote, { attrs: blockAttrs });
};
export {
  AgentShoppingBlock as default
};
